// extracted by mini-css-extract-plugin
export default {"logo":"styles_logo__XzzR6","image":"styles_image__OOgdm","name":"styles_name__xPT4C","link":"styles_link__ke0Mu"};